import FlexBox from '@/atomic-components/FlexBox';
import CategoryTiles, {
	CategoryData,
} from '@/components/listing/category-tiles';
import FiltersTile, { FilterTileData } from '@/components/listing/filters-tile';
import SortTiles, { SortData } from '@/components/listing/sort-tiles';
import ProductTileFour from '@/components/ProductTile4';
import { IProductData } from '@/components/search-results/model';
import ListingSkeleton from '@/components/search-results/listing-skeleton';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import {
	Container,
	Drawer,
	MenuItem,
	Select,
	SelectChangeEvent,
	Skeleton,
} from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { Box } from '@mui/system';
import { useRouter } from 'next/router';
import DownArrow from '@/assets/arrow_down.svg';
import { useEffect, useState } from 'react';
import FiltersDrawer from '@/components/listing/filters-drawer';
import { ListingService } from '@/services/catalogue';
import SelectedFilterTile from '@/components/listing/selected-filter-tile';
import GenericErrorScreen from '@/components/ErrorScreen';
import ListingError from '@/assets/ListingError.svg';
import { dataLayerPushWithEvent } from '@/utils/dataLayer';
import { PlpFooter } from '@/components/listing/plp-footer';
import { setSeoData } from '@/store/seo/seoSlice';
import { useLocation } from '@/hooks/useLocation';
import { useDispatch, useSelector } from 'react-redux';
import Footer from '@/components/Footers';
import { ProvideFullScreenLoader } from '@/hooks/useFullScreenLoader';
import { ApiState } from '@/models/generics';
import { ParsedUrlQuery } from 'querystring';
import Link from 'next/link';
import { PdpUrlHelper } from '@/utils/seo-url-helper';
import useBadgeData from '@/hooks/useBadge';

const queryToBePassedToPdp = (query: ParsedUrlQuery) => {
	let queryString = '';

	for (let key in query) {
		if (key.includes('filters')) {
			const values = query[key];
			if (Array.isArray(values)) {
				values.forEach((value) => {
					queryString += `${key}=${value}&`;
				});
			} else {
				queryString += `${key}=${values}&`;
			}
		}
	}

	return queryString;
};

const LOP = [
	{
		name: 'All',
		label: 'BUY_ALL',
	},
	{
		name: 'Brand New',
		label: 'BUY_NEW',
	},
	{
		name: 'Refurbished',
		label: 'BUY_REFURBISHED',
	},
];

export enum lineOfProduct {
	CATEGORY_BUY = 'BUY_ALL',
	CATEGORY_RENT = 'RENT',
	BUY_NEW = 'BUY_NEW',
	BUY_REFURBISHED = 'BUY_REFURBISHED',
}

export const getQueryString = (
	routerQuery: any,
	prefix = '',
	seachParams = new URLSearchParams()
) => {
	Object.entries(routerQuery).forEach(([key, val]: any) => {
		if (Array.isArray(val)) {
			val.forEach((arraryElement) => {
				seachParams.append(`${prefix}${key}`, arraryElement);
			});
		} else {
			seachParams.append(prefix ? `${prefix}${key}` : key, val);
		}
	});

	return seachParams;
};

export const getAllFilters = (
	params: URLSearchParams,
	selectedFilters: { key: string; val: string }[]
) => {
	selectedFilters.map((filter) => {
		params.append(`filters[${filter.key}]`, filter.val);
	});
};

function Listing() {
	const { selectedLocation } = useLocation();
	const { isLoggedIn } = useSelector((state: any) => {
		return state.user;
	});
	const router = useRouter();
	const dispatch: any = useDispatch();
	const [iserrored, setIsErrored] = useState(false);
	const [selectedLOP, setSelectedLOP] = useState('');
	const [products, setProducts] = useState<IProductData[] | null>();
	const [categories, setCategories] = useState<CategoryData[] | null>();
	const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
	const [plpSeoContent, setPlpSeoContent] = useState({});
	const [sortOptions, setSortOptions] = useState<SortData[] | null>();
	const [selectedSort, setSelectedSort] = useState<string>();
	const [filters, setFilters] = useState<FilterTileData[] | null>();
	const [preSelectedFilters, setPreSelectedFilters] =
		useState<{ key: string; val: string }[]>();
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [getProductsApiState, setGetProductsApiState] = useState<ApiState>(
		ApiState.LOADING
	);
	const [selectedFilters, setSelectedFilters] = useState<string>('');
	const badgeData = useBadgeData();

	const getProducts = async (query = new URLSearchParams()) => {
		const res = await ListingService.getProductListings(query);

		return res.data;
	};

	const updatePlpSeoContent = () => {
		if (selectedLocation && router?.query?.collectionName) {
			const cityName = selectedLocation.cityName;
			ListingService.getListingMeta(
				router?.query?.collectionName as string
			).then((res) => {
				setPlpSeoContent({
					footer: res.data?.data?.collectionMeta?.footer?.replaceAll(
						'[City]',
						cityName
					),
					schemas: res.data?.data?.collectionMeta?.schemas,
				});
				dispatch(
					setSeoData({
						title: res.data.data?.collectionMeta?.title?.replaceAll(
							'[City]',
							cityName
						),
						description: res.data.data?.collectionMeta?.description,
						footerData: '',
						schemas: res.data?.data?.collectionMeta?.schemas,
					})
				);
			});
		}
	};

	useEffect(() => {
		updatePlpSeoContent();
	}, [router?.query?.collectionName as string, selectedLocation.cityName]);

	// console.log(filters,categories)

	const getListing = async () => {
		setIsErrored(false);
		setGetProductsApiState(ApiState.LOADING);
		setProducts(null);
		setCategories(null);
		setSortOptions(null);
		setFilters(null);
		return getProducts(getQueryString(router.query))
			.then((filterResponse: any) => {
				setProducts(filterResponse?.data?.products);
				setCategories(filterResponse?.data?.categories);
				setSortOptions(filterResponse?.data?.sortOptions);
				// setFilters(filterResponse?.data?.filterOptions);

				if (filterResponse?.data?.categories) {
					const fil = [
						...filterResponse?.data?.categories?.filter((x: any) => {
							return x.name == router?.query?.collection;
						}),
					];
					let finalData = [
						{
							...filterResponse?.data?.filterOptions?.filter((x: any) => {
								return x.value == 'sub_category';
							})[0],
						},
						...filterResponse?.data?.filterOptions?.filter((x: any) => {
							return x.value != 'sub_category';
						}),
					];
					if (fil.length) {
						finalData[0].options = fil[0]?.children;
					}
					// console.log(finalData,'final')
					setFilters(finalData);
				} else {
					setFilters(filterResponse?.data?.filterOptions);
				}

				setSelectedSort(
					Array.isArray(filterResponse?.data?.sortOptions) &&
						filterResponse?.data?.sortOptions[0]?.label
				);
				if (router?.query?.collectionType) {
					setSelectedLOP(
						lineOfProduct[
							router?.query?.collectionType as keyof typeof lineOfProduct
						]
					);
				}
				if (router?.query?.collection) {
					setSelectedCategory(router?.query?.collection as string);
				}
				if (router?.query?.lineOfProduct) {
					setSelectedLOP(
						lineOfProduct[
							router?.query?.lineOfProduct as keyof typeof lineOfProduct
						]
					);
				}
				if (router?.query?.sortBy) {
					setSelectedSort(router.query.sortBy as string);
				}
				let selectedFiltersData: any = [];
				for (const [key, value] of Object.entries(router.query)) {
					if (key.includes('filter')) {
						const tempKey = key.split('[')[1].split(']')[0];
						if (Array.isArray(value)) {
							selectedFiltersData = value.reduce((acc: any, fData) => {
								acc = [...acc, { key: tempKey, val: fData }];
								return acc;
							}, []);
						} else {
							selectedFiltersData = [
								...selectedFiltersData,
								{ key: tempKey, val: value },
							];
						}
					}
				}
				setPreSelectedFilters(selectedFiltersData);
			})
			.catch((err) => {
				setIsErrored(true);
			})
			.finally(() => {
				setGetProductsApiState(ApiState.COMPLETED);
			});
	};
	// console.log(filters)
	useEffect(() => {
		setIsErrored(false);
		if (selectedLocation.cityId && router?.query?.collectionType) {
			router?.query?.collectionType == 'CATEGORY_RENT' &&
				dataLayerPushWithEvent('moe_event', {
					moe_event_name: 'PLP Page Loaded',
					moe_event_data: {
						collection: router?.query?.collection,
					},
				});
			router?.query?.collectionType == 'CATEGORY_BUY' &&
				dataLayerPushWithEvent('moe_event', {
					moe_event_name: 'Buy PLP Page Loaded',
					moe_event_data: {
						collection: router?.query?.collection,
						buy_type: router?.query?.lineOfProduct
							? router?.query?.lineOfProduct
							: 'ALL',
					},
				});
			router?.query?.collectionType == 'GENERIC_COLLECTION' &&
				dataLayerPushWithEvent('moe_event', {
					moe_event_name: 'Custom PLP Page Loaded',
					moe_event_data: {
						collection: router?.query?.collection,
					},
				});
			getListing();
		}
		triggerPlpView();
		setSelectedFilters(queryToBePassedToPdp(router.query));
	}, [router?.query, isLoggedIn, selectedLocation]);

	const triggerPlpView = () => {
		let lop;
		if (
			router?.query?.collectionType === 'CATEGORY_RENT' ||
			router?.query?.collectionType === 'CATEGORY_BUY'
		) {
			const lopFormQp = router?.query.lineOfProduct;
			lop =
				(router?.query?.collectionType === 'CATEGORY_RENT' && 'RENT') ||
				lopFormQp ||
				'BUY_ALL';
		}
		dataLayerPushWithEvent('plp_viewed', {
			plp_lop: lop,
			plp_collection_name: router?.query?.collection,
		});
	};

	const SwitchLOP = (e: SelectChangeEvent) => {
		setSelectedLOP(e.target.value);
		const params = new URLSearchParams();
		if (router?.query?.collection) {
			params.append('collection', router?.query?.collection as string);
		}
		if (router?.query?.sortBy) {
			params.append('sortBy', router?.query?.sortBy as string);
		}
		if (e.target.value == 'RENT') {
			params.append('collectionType', 'CATEGORY_RENT');
		}
		if (e.target.value == 'BUY_ALL') {
			params.append('collectionType', 'CATEGORY_BUY');
		}
		if (e.target.value == 'BUY_NEW' || e.target.value == 'BUY_REFURBISHED') {
			params.append('collectionType', 'CATEGORY_BUY');
			params.append('lineOfProduct', e.target.value);
		}

		setProducts(undefined);
		router.push(`/listing?${params.toString()}`);
	};

	const clearAllFilters = () => {
		const params = new URLSearchParams({
			collectionType: router?.query?.collectionType as string,
		});
		if (router?.query?.collection) {
			params.append('collection', router.query.collection as string);
		}
		if (router?.query?.lineOfProduct) {
			params.append('lineOfProduct', router.query.lineOfProduct as string);
		}
		if (router?.query?.sortOptions) {
			params.append('sortBy', router.query.sortOptions as string);
		}
		router.push(`/listing?${params.toString()}`);
	};
	const onCategoryChange = (categoryName: string) => {
		setSelectedCategory(categoryName);
		const params = new URLSearchParams({
			collectionType: router?.query?.collectionType as string,
		});
		if (router?.query?.sortBy) {
			params.append('sortBy', router?.query?.sortBy as string);
		}
		if (router?.query?.lineOfProduct) {
			params.append('lineOfProduct', router.query.lineOfProduct as string);
		}
		params.append('collection', categoryName);

		router.push(`/listing?${params.toString()}`);
	};
	const onSortChange = (sortName: string) => {
		setSelectedSort(sortName);
		const params = new URLSearchParams({
			collectionType: router?.query?.collectionType as string,
		});
		if (router?.query?.collection) {
			params.append('collection', router.query.collection as string);
		}
		if (router?.query?.lineOfProduct) {
			params.append('lineOfProduct', router.query.lineOfProduct as string);
		}
		preSelectedFilters && getAllFilters(params, preSelectedFilters);
		params.append('sortBy', sortName);
		router.push(`/listing?${params.toString()}`);
	};
	const onFilterChange = (selectedFilters: { key: string; val: string }[]) => {
		const params = new URLSearchParams({
			collectionType: router?.query?.collectionType as string,
		});
		if (router?.query?.collection) {
			params.append('collection', router.query.collection as string);
		}
		if (router?.query?.lineOfProduct) {
			params.append('lineOfProduct', router.query.lineOfProduct as string);
		}
		if (router?.query?.sortOptions) {
			params.append('sortBy', router.query.sortOptions as string);
		}
		getAllFilters(params, selectedFilters);
		router.push(`/listing?${params.toString()}`);
	};
	const onSingleFilterRemove = (key: string, val: string) => {
		const params = new URLSearchParams({
			collectionType: router?.query?.collectionType as string,
		});
		if (router?.query?.collection) {
			params.append('collection', router.query.collection as string);
		}
		if (router?.query?.lineOfProduct) {
			params.append('lineOfProduct', router.query.lineOfProduct as string);
		}
		if (router?.query?.sortOptions) {
			params.append('sortBy', router.query.sortOptions as string);
		}
		const filterData = preSelectedFilters?.filter((x: any) => {
			return x.val != val;
		});
		setPreSelectedFilters(filterData);
		filterData && getAllFilters(params, filterData);
		router.push(`/listing?${params.toString()}`);
	};
	return (
		<ProvideFullScreenLoader>
			<Container maxWidth='xl' sx={{ margin: '10px auto', padding: '0 32px' }}>
				{!iserrored ? (
					<Box>
						<FlexBox sx={{ justifyContent: 'start' }}>
							{router?.query?.collectionType == 'CATEGORY_BUY' && (
								<Select
									value={selectedLOP}
									defaultValue={selectedLOP}
									onChange={(e) => SwitchLOP(e)}
									variant={'filled'}
									sx={{
										marginRight: '8px',
										'.MuiSelect-select': {
											padding: '14px 14px 0 14px',
											...getStyle('H10A_Regular'),
										},
									}}
								>
									{LOP.map((lop) => {
										return (
											<MenuItem
												key={lop.name}
												sx={{ ...getStyle('H10A_Regular') }}
												value={lop.label}
											>
												{lop.name}
											</MenuItem>
										);
									})}
								</Select>
							)}
							<FlexBox
								sx={{
									justifyContent: 'start',
									whiteSpace: 'nowrap',
									overflowX: 'scroll',
									'::-webkit-scrollbar': { display: 'none' },
								}}
							>
								{getProductsApiState != ApiState.LOADING ? (
									categories?.map((d) => {
										return (
											<CategoryTiles
												key={d.label}
												data={d}
												selectedCategory={selectedCategory}
												setSelectedCategory={setCategories}
												lineOfProduct={selectedLOP}
											/>
										);
									})
								) : (
									<>
										{[1, 2, 3, 4, 5].map((d) => {
											return (
												<Skeleton
													key={d}
													variant='rectangular'
													animation='wave'
													height={'50px'}
													width={'120px'}
													sx={{ margin: '0 20px', borderRadius: '8px' }}
												/>
											);
										})}
									</>
								)}
							</FlexBox>
						</FlexBox>
						<Box sx={{ margin: '24px 0' }}>
							{preSelectedFilters && preSelectedFilters.length > 0 && (
								<FlexBox
									sx={{
										justifyContent: 'start',
										alignItems: 'center',
										width: '100%',
									}}
								>
									<Box>
										<LencoTypography
											sx={{
												...getStyle('P_Regular'),
												color: getColor('Gray -1'),
											}}
										>
											Filters Applied:{' '}
										</LencoTypography>
									</Box>
									{preSelectedFilters?.map((filters) => {
										return (
											<SelectedFilterTile
												key={filters.key}
												data={filters}
												onFilterChange={onSingleFilterRemove}
											/>
										);
									})}
								</FlexBox>
							)}
							<FlexBox
								sx={{
									justifyContent: 'space-between',
									alignItems: 'center',
									width: '100%',
								}}
							>
								<FlexBox
									sx={{
										justifyContent: 'start',
										alignItems: 'center',
										width: '100%',
										whiteSpace: 'nowrap',
									}}
								>
									<LencoTypography>
										{getProductsApiState == ApiState.LOADING ? (
											<Skeleton
												variant='rectangular'
												animation='wave'
												height={'24px'}
												width={'100px'}
												sx={{
													margin: '0 10px 10px 0px',
													borderRadius: '24px',
													marginTop: '24px',
												}}
											/>
										) : (
											filters && 'FILTERS'
										)}{' '}
									</LencoTypography>
									<FlexBox
										sx={{
											position: 'relative',
											justifyContent: 'start',
											width: '100%',
											// flexWrap: 'nowrap',
											alignItems: 'center',
											marginLeft: '8px',
										}}
									>
										{getProductsApiState == ApiState.LOADING ? (
											<>
												{[1, 2, 3].map((d) => {
													return (
														<Skeleton
															key={d}
															variant='rectangular'
															animation='wave'
															height={'38px'}
															width={'200px'}
															sx={{
																margin: '0 8px',
																borderRadius: '24px',
																mt: '12px',
															}}
														/>
													);
												})}
											</>
										) : (
											filters?.slice(0, 2).map((filter) => {
												return (
													<FiltersTile
														key={filter.value}
														data={filter}
														onFilterConfirm={onFilterChange}
														preSelectedFilters={preSelectedFilters}
													/>
												);
											})
										)}
										{filters && (
											<Box
												sx={{
													position: 'relative',
													padding: '8px 16px',
													border: `1px solid ${getColor('Gray -2')}`,
													margin: '8px',
													borderRadius: '24px',
													whiteSpace: 'nowrap',
												}}
											>
												<FlexBox
													sx={{
														justifyContent: 'space-between',
														alignItems: 'center',
														cursor: 'pointer',
													}}
													onClick={() => setIsDrawerOpen(!isDrawerOpen)}
												>
													<LencoTypography
														sx={{
															...getStyle('Small_Medium'),
															color: getColor('Gray -2'),
															marginRight: '100px',
														}}
													>
														+{filters?.slice(0, 3)?.length} options available
													</LencoTypography>
													<Box sx={{ transform: 'rotate(270deg)' }}>
														<DownArrow />
													</Box>
												</FlexBox>
											</Box>
										)}
									</FlexBox>
								</FlexBox>
								<FlexBox sx={{ justifyContent: 'start', alignItems: 'center' }}>
									<LencoTypography
										sx={{
											...getStyle('P_Medium'),
											color: getColor('Gray -2'),
											whiteSpace: 'nowrap',
										}}
									>
										{getProductsApiState == ApiState.LOADING ? (
											<Skeleton
												variant='rectangular'
												animation='wave'
												height={'24px'}
												width={'100px'}
												sx={{ margin: '0 10px', borderRadius: '24px' }}
											/>
										) : (
											sortOptions && 'SORT BY'
										)}
									</LencoTypography>
									<Box sx={{ marginLeft: '16px' }}>
										{getProductsApiState == ApiState.LOADING ? (
											<Skeleton
												variant='rectangular'
												animation='wave'
												height={'38px'}
												width={'150px'}
												sx={{ margin: '0 8px', borderRadius: '24px' }}
											/>
										) : (
											sortOptions && (
												<SortTiles
													data={sortOptions}
													setSelectedSort={onSortChange}
													selectedSort={selectedSort as string}
												/>
											)
										)}
									</Box>
								</FlexBox>
							</FlexBox>
						</Box>
						{filters && (
							<FiltersDrawer
								open={isDrawerOpen}
								onClose={setIsDrawerOpen}
								filters={filters}
								preSelectedFilters={preSelectedFilters}
								clearAllFilter={clearAllFilters}
								onFilterConfirm={onFilterChange}
							/>
						)}
						{products ? (
							products.length > 0 ? (
								<>
									<FlexBox
										fullWidth
										sx={{
											justifyContent: 'center',
											flexWrap: 'wrap',
											background: getColor('Gray -7'),
											padding: '16px',
											paddingTop: '30px',
											':hover': {
												zIndex: 11,
											},
										}}
									>
										{products?.map((product: IProductData) => {
											const url = PdpUrlHelper({
												permalink: product.permalink,
												lop: product.lineOfProduct,
											});

											return (
												<Box
													sx={{ width: 'calc(25% - 56px)', m: '14px' }}
													key={product.permalink}
												>
													<Link
														href={{
															pathname: url,
															query: selectedFilters,
														}}
														as={url}
														style={{ width: '100%', height: '100%' }}
													>
														<ProductTileFour
															key={product.id}
															data={product}
															badgesInfo={badgeData}
														/>
													</Link>
												</Box>
											);
										})}
									</FlexBox>
									{plpSeoContent && Object.keys(plpSeoContent).length > 0 && (
										<PlpFooter
											seoContent={plpSeoContent}
											collapsed={false as boolean}
										/>
									)}
								</>
							) : (
								<GenericErrorScreen
									image={ListingError}
									title='No Products Found'
									subtitle='Clear these filters for available furniture'
								/>
							)
						) : (
							<ListingSkeleton />
						)}
					</Box>
				) : (
					<GenericErrorScreen
						image={ListingError}
						title='Something Went Wrong'
						subtitle='We are unable to load the page'
					/>
				)}
			</Container>
			<Footer />
		</ProvideFullScreenLoader>
	);
}

export default Listing;
